<script setup lang="ts">
import { useStudyStore } from '@/stores/study';
import { onMounted } from 'vue';
import ProgressSpinner from 'primevue/progressspinner';
import { useRouter } from 'vue-router';
import { routeConstants } from '@/utils';

const studyStore = useStudyStore();
const router = useRouter();

onMounted(() => {
  (async () => {
    await studyStore.getStudies();
    const selectedStudyId = studyStore.selectedStudyId;
    if (!selectedStudyId) {
      // if user has no studies, redirect to onboarding page
      router.push({
        name: routeConstants.ONBOARDING.name
      });
      return;
    }
    router.push({
      name: routeConstants.DATA.name,
      params: { studyIdentifier: selectedStudyId }
    });
  })();
});

</script>

<template>
  <div class="study-progress">
    <ProgressSpinner strokeWidth="4" />
  </div>
</template>

<style scoped lang="scss">
.study-progress {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
